import axios from 'axios';

const isCancel = axios.isCancel;

export { isCancel };
